var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNationalDigital = function SvgNationalDigital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 694 1234"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 0.944,
    fill: "url(#national-digital_svg__a)",
    transform: "matrix(0 192.605 193.843 0 510.385 598.604)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 0.944,
    fill: "url(#national-digital_svg__b)",
    transform: "scale(193.843 192.605)rotate(90 0 .944)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 0.944,
    fill: "url(#national-digital_svg__c)",
    transform: "matrix(0 192.605 193.843 0 190.286 1051.52)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "national-digital_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.2167 1.1347 1.2024 -.2297 -.217 -.135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2c49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#eea469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ea822d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c77c22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c35d00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "national-digital_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.2167 1.1347 1.2024 -.2297 -.217 -.135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2c49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#eea469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ea822d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c77c22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c35d00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "national-digital_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.2167 1.1347 1.2024 -.2297 -.217 -.135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2c49b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#eea469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ea822d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c77c22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c35d00"
  })))));
};
export default SvgNationalDigital;